import type {
  CostSummaryItem,
  VendorSpendItem,
  PaymentStatusItem,
  IncomeReport,
} from '@peles/shared';
import { apiClient } from './client';

export async function getEventCostSummary(eventId: string): Promise<CostSummaryItem[]> {
  const { data } = await apiClient.get<CostSummaryItem[]>('/reports/event-cost-summary', {
    params: { eventId },
  });
  return data;
}

export async function getVendorSpend(): Promise<VendorSpendItem[]> {
  const { data } = await apiClient.get<VendorSpendItem[]>('/reports/vendor-spend');
  return data;
}

export async function getPaymentStatus(eventId?: string): Promise<PaymentStatusItem[]> {
  const params: Record<string, string> = {};
  if (eventId) params.eventId = eventId;
  const { data } = await apiClient.get<PaymentStatusItem[]>('/reports/payment-status', { params });
  return data;
}

export async function getIncomeReport(filters?: {
  startDate?: string;
  endDate?: string;
}): Promise<IncomeReport> {
  const params: Record<string, string> = {};
  if (filters?.startDate) params.startDate = filters.startDate;
  if (filters?.endDate) params.endDate = filters.endDate;
  const { data } = await apiClient.get<IncomeReport>('/reports/income', { params });
  return data;
}
